import * as React from "react";
import Form from "react-bootstrap/Form";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import Cookies from "js-cookie";
import axios from "axios";
import { BASE_URL } from "../../Landing/Components/Api/Api";
import SweetAlert from "../../Landing/Components/SweetAlert/SweetAlert";
import Button from "react-bootstrap/Button";
import { ConfirmDialog, confirmDialog } from "primereact/confirmdialog";
import { Toast } from "primereact/toast";
import { fetchData } from "./Utilities";
import { InputFormat } from "../../Landing/Components/FormOptions/InputFormat";
import { Col, Row } from "react-bootstrap";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import Swal from "sweetalert2";
export const ShopSliderSetBox = () => {
  const [showEditComponent, setShowEditComponent] = useState(false);
  const [image, setImage] = useState("");
  const [validationError, setValidationError] = useState(false);
  const toast = useRef(null);

  const reject = () => {
    toast.current.show({
      severity: "warn",
      summary: "لغو شد",
      detail: "درخواست حذف لغو شد",
      life: 3000,
    });
  };
  const [initialValues, setIntialValues] = useState([]);

  const [Logo, setLogo] = useState({});

  useEffect(() => {
    fetchData("banner", {}, handleApiResponse);
  }, []);

  const handleApiResponse = (data) => {
    // Your response handling logic here
    const initData = data?.dt?.filter((img) => img.Position === 0);
    setIntialValues(initData);
    reset({ ...initData });
  };

  const defaultValues = {
    title: "",
    link: "",
    img: "",
    sort: "",
    BannerId: "",
  };

  const {
    handleSubmit,
    reset,
    control,
    formState: { errors },
  } = useForm({ defaultValues });
  const onSubmit = async (data) => {
    const bodyFormData = new FormData();
    bodyFormData.append("bannerId", data?.BannerId || 0);
    bodyFormData.append("position", 0);
    bodyFormData.append("title", data?.title);
    bodyFormData.append("link", data?.link);
    bodyFormData.append("sort", data?.sort);
    bodyFormData.append("image", typeof image === "string" ? "" : image);
    bodyFormData.append("guid", Cookies.get("guid"));
    if (!image) {
      setValidationError(true);
    } else if (image) {
      setValidationError(false);
    }
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "updatebanner",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (!validationError) {
          SweetAlert({
            title: "",
            text: "اطلاعات اولیه با موفقیت ذخیره شد.",
            type: "success",
          });
        }
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const handleUpload = async (w, h, sednFile) => {
    if (!sednFile) {
      return;
    }
    const image = new Image();
    image.src = sednFile;
    const cWith = w;
    const cHeight = h;
    let percentWidth = 0;
    let percentHeight = 0;
    image.onload = async () => {
      const canvas = document.createElement("canvas");
      const orginalWidht = image.naturalWidth;
      const orginalHeight = image.naturalHeight;
      if (cWith === 0 || cHeight === 0) {
        canvas.width = image.naturalWidth;
        canvas.height = image.naturalHeight;
      } else {
        percentWidth = cWith / orginalWidht;
        percentHeight = cHeight / orginalHeight;
        const percent =
          percentHeight < percentWidth ? percentHeight : percentWidth;
        canvas.width = image.naturalWidth * percent;
        canvas.height = image.naturalHeight * percent;
      }

      canvas
        .getContext("2d")
        .drawImage(image, 0, 0, canvas.width, canvas.height);
      canvas.toBlob(async (blob) => {
        const myImage = new File([blob], "my-new-name.webp", {
          type: blob.type,
        });

        setImage(myImage);
      }, "image/webp");
    };
  };
  const handleSendImage = (slide) => {
    const width = 800;
    const height = 800;
    handleUpload(width, height, Logo);
  };

  const handleDeleteImage = async (id) => {
    const bodyFormData = new FormData();
    bodyFormData.append("bannerId", id);
    try {
      const responseGlobal = await axios.post(BASE_URL, bodyFormData, {
        headers: {
          cmd: "deletebanner",
          "Content-Type": "multipart/form-date",
        },
      });
      if (responseGlobal.status === 200) {
        if (responseGlobal?.data?.UserId === "0") {
        }
        toast.current.show({
          severity: "info",
          summary: "تایید شد",
          detail: "درخواست شما انجام شد",
          life: 3000,
        });
        fetchData("banner", {}, handleApiResponse);
        setImage(null);
      } else {
        console.error(
          `API request failed with status: ${responseGlobal.status}`
        );
      }
    } catch (error) {
      console.error("Error while fetching menu data:", error);
    }
  };

  const handleDelete = (id) => {
    Swal.fire({
      show: true,
      title: "حذف بنر",
      text: "آیا می خواهید بنر را حذف کنید؟",
      showConfirmButton: true,
      showCancelButton: true,
      confirmButtonText: "بله",
      cancelButtonText: "خیر",
      cancelButtonColor: "#d33",
      icon: "success",
    }).then(async (result) => {
      if (result.isConfirmed) {
        await handleDeleteImage(id);
      }
    });
  };

  const submitEdit = (slide) => {
    if (slide?.img) {
      setValidationError(false);
    }
    setShowEditComponent(true);
    if (slide) {
      reset({ ...slide });
      setImage(slide?.img ?? null);
    } else {
      reset(defaultValues);
      setImage(null);
    }
  };

  return (
    <>
      <Toast ref={toast} />
      <ConfirmDialog />
      <Form dir="rtl" onSubmit={handleSubmit(onSubmit)}>
        <div className="panel panel-primary">
          <div className="panel-heading text-info prime-bg text-white text-center py-2 my-0">
            بنر فروشگاه
          </div>
          <div className="panel-body ">
            <div className="row hidden-xs">
              <div className="col-md-2 nopaddingmob col-xs-4">اولویت</div>
              <div className="col-md-2 nopaddingmob col-xs-4">عنوان</div>
              <div className="col-md-3 nopaddingmob col-xs-4">لینک</div>
              <div className="col-md-2 nopaddingmob col-xs-4">عکس</div>
              <hr className="hidden-xs" />
            </div>
            {initialValues?.map((slide) => {
              return (
                <div
                  key={slide?.BannerId}
                  className="row d-flex justify-content-between align-items-center  multi-slide-box"
                >
                  <div className=" col-md-6 mauto nopaddingmob col-xs-9 ">
                    <div className="d-flex flex-row align-items-center justify-content-between gap-1">
                      <p>{slide?.sort}</p>
                      <p>{slide?.title}</p>
                      <p>{slide?.link}</p>
                    </div>
                  </div>

                  <div className="col-md-4 mauto nopaddingmob col-xs-12 pb-2">
                    <br className="hidden-md" />
                    <span className="hidden-md">جهت تغییر عکس را لمس کنید</span>
                    <img
                      className="banner-set-image rounded"
                      alt="عکس بنر را انتخاب کنید.."
                      src={`https://api.taab30.com${slide?.img}`}
                    />
                  </div>
                  <div className="col-md-1 mauto nopaddingmob col-xs-12 ">
                    <div className="d-flex flex-column justify-content-between align-items-center gap-1">
                      <Button
                        onClick={() => handleDelete(slide?.BannerId)}
                        type="button"
                        className="btn btn-danger"
                      >
                        <FontAwesomeIcon icon={"remove"} className="fs-6 " />
                      </Button>
                      <Button type="button" onClick={() => submitEdit(slide)}>
                        <FontAwesomeIcon icon={"edit"} className="fs-6" />
                      </Button>
                    </div>
                  </div>
                </div>
              );
            })}
            <div className="row">
              <div className="col-12 m-2">
                <Button className="" onClick={() => submitEdit()}>
                  {" "}
                  افزودن بنر جدید
                </Button>
              </div>
            </div>

            {showEditComponent && (
              <>
                <div className="panel-heading text-info prime-bg text-white text-center py-2 my-0 ">
                  افزودن بنر اسلایدر - ابعاد :
                  <span id="ContentPlaceHolder1_lblsizemainbanner">
                    1780x890px
                  </span>
                </div>
                <Row>
                  <Col className="col-12 col-lg-6">
                    <InputFormat
                      control={control}
                      name="sort"
                      type={"tel"}
                      defaultValue={""}
                      label="اولویت"
                      errors={errors}
                    />
                  </Col>
                  <Col className="col-12 col-lg-6">
                    <InputFormat
                      control={control}
                      name="title"
                      type={"text"}
                      label="عنوان "
                      errors={errors}
                    />
                  </Col>
                </Row>
                <Row>
                  <Col className="col-12 col-lg-6">
                    <InputFormat
                      control={control}
                      name="link"
                      type={"text"}
                      label="لینک"
                      errors={errors}
                    />
                  </Col>
                  <Col className="col-12 col-lg-6">
                    <br className="hidden-md" />
                    <span className="hidden-md">جهت تغییر عکس را لمس کنید</span>
                    <img
                      onClick={() =>
                        document.getElementById("fileInput").click()
                      }
                      className="banner-set-image rounded"
                      alt="عکس بنر را انتخاب کنید"
                      src={
                        typeof image === "string"
                          ? `https://api.taab30.com${image}`
                          : `${Logo}`
                      }
                    />
                    <input
                      type="file"
                      id="fileInput"
                      className="d-none"
                      onChange={(e) => {
                        if (e.target.files.length > 0) {
                          setLogo(URL.createObjectURL(e.target.files[0]));
                        }
                        setTimeout(() => {
                          document.getElementById("btn-upload").click();
                        }, 1);
                      }}
                    />
                    <button
                      id="btn-upload"
                      className="d-none"
                      type="button"
                      onClick={() => handleSendImage()}
                    >
                      click
                    </button>
                  </Col>
                  {validationError && (
                    <span className="text-danger">عکس انتخاب نشده است</span>
                  )}
                </Row>
                <Row>
                  <Col className="col-12 col-lg-6"></Col>
                  <Col className="col-12 col-lg-6">
                    <div className="d-flex flex-row justify-content-center mt-5 align-items-between gap-2">
                      <Button
                        className="bg-info btn"
                        onClick={() =>
                          document.getElementById("fileInput").click()
                        }
                        type="button"
                      >
                        انتخاب عکس
                      </Button>

                      <Button type="submit" className="bg-success">
                        ذخیره
                      </Button>
                    </div>
                  </Col>
                </Row>
              </>
            )}
          </div>
        </div>
      </Form>
    </>
  );
};
